import React, { useEffect } from 'react';
import { formatMoney } from "../../common/money";
import Prev from "../../assets/icons/coloredPrev.svg";
import { useNavigate,useLocation } from 'react-router-dom';
 
import icon from "../../assets/icons/ChatText.svg"
import axios from 'axios';
import { toast } from 'react-toastify';
import useAuth from '../../customHooks/useAuth';
import { baseUrl } from '../../common/baseUrl';
import Remarks from '../components/Remarks/Remarks';
import axiosInstance from '../../axiosInstance/axiosInstance';
 

export default function RestaurantDiningDecision() {
  
    const navigate = useNavigate();
    const location = useLocation();
    const foodData = location.state?.foodData || [];
    const guestRequestId = foodData.guest_request_id;    
    const userId = location.state?.userId || "";
    const bookingId = location.state?.bookingId || "";
    const bookedRoomId = location.state?.bookedRoomId || "";
    const staffStatus = location.state?.staffStatus || "";
    const tableNumber = location.state?.tableNumber || "";

    // Refresh Handle 
    useAuth();

    // console.log("Food Data : " + foodData.food_items);

    const moveBack = ()=>{
        navigate("/bookings",{state : {activeRequests : "requests"}});    
    }

    // Check If the foodData is there or not 
    useEffect(()=>{
        if(foodData.length===0){
            navigate("/bookings",{state : {activeRequests : "requests"}});
        }
    },[]);

    const closeRequest = async()=>{
        // console.log("Close Request");
        try{
            const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${guestRequestId}/close`);

            // console.log("Response For Cancel Food Request : ",response); 
            toast.success("Restaurant Dining Request Cancelled Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}});

        }catch(error){
            toast.error(error.response.data.message);
            console.log(error);
        }
    }



    const renderFoodRequestButtons = () => {
        if (["Completed_Hotel", "Completed_Guest", "Declined_Guest", "Declined_Hotel", "Closed_Guest"].includes(foodData.status)) {
          return <div></div>;
        }
      
        if (foodData.status === "Pending_Hotel") {
          return (
            <div className="dining-btn">
                <button onClick={closeRequest}>Cancel Request</button>
            </div>
          );
        }
      
 
      
        if (["InProgress_Hotel", "Scheduled_Hotel"].includes(foodData.status)) {
          return (
            <div className="fee-btns">
              <div className="cancel-btn">
                <button onClick={closeRequest}>Cancel Request</button>
              </div>
            </div>
          );
        }
      
        return <div></div>;
      };


  
    // The total is no longer just the sum of the lines above it: a promo discount comes off
    // and GST goes back on, so each component is shown rather than leaving the guest to
    // wonder why the figure does not match the dishes.
    const subtotal = (foodData?.food_items || []).reduce(
        (total, item) => total + (item.price || 0) * (item.quantity || 0),
        0,
    );
    const discountAmount = Number(foodData?.discount_amount) || 0;
    const taxAmount = Number(foodData?.tax_amount) || 0;
    const payableTotal = subtotal - discountAmount + taxAmount;

    return (
    <div className="diningDecision">
        <div className="dining-header">
            <img src={Prev} alt="Error" onClick={moveBack} />
            <h3>Food Order Summary</h3>
        </div>
        <Remarks food="food" para = "Food Preparation will take approximately 25 Minutes" />
        {
            foodData.remarks &&
            <div className="dining-remarks">
                <div className='dining-remark-img'>
                    <img src={icon} alt='' />
                </div>
                <div className='dining-remark-text'>
                    <h5>
                        Remarks :
                    </h5>
                    <p>
                        {foodData.remarks}
                    </p>
                </div>
            </div>
        }


        <div className="dining-menu">

            {staffStatus && 
                <div className="dining-status">
                    <h4>Staff Assigned</h4>
                </div>
            }
            
            <div className="food-items">
                { 
                    foodData.food_items.map((food, index) => (
                        <div className="food-item" key={index}>
                            <div className="food-item-name">{food.name} x{food.quantity}</div>
                            <div className="food-item-price">₹ {food.price}</div>
                        </div>
                    ))
                }
                <div className="food-total food-line">
                    <div className="food-total-text">
                        <p>Subtotal</p>
                    </div>
                    <div className="food-total-num">
                        <p>₹ {formatMoney(subtotal)}</p>
                    </div>
                </div>

                {discountAmount > 0 && (
                    <div className="food-total food-line">
                        <div className="food-total-text">
                            <p>Discount</p>
                        </div>
                        <div className="food-total-num">
                            <p>- ₹ {formatMoney(discountAmount)}</p>
                        </div>
                    </div>
                )}

                {taxAmount > 0 && (
                    <div className="food-total food-line">
                        <div className="food-total-text">
                            <p>GST</p>
                        </div>
                        <div className="food-total-num">
                            <p>+ ₹ {formatMoney(taxAmount)}</p>
                        </div>
                    </div>
                )}

                <div className="food-total">
                    <div className="food-total-text">
                        <p>Total</p>
                    </div>
                    <div className="food-total-num">
                        <p>₹ {formatMoney(payableTotal)}</p>
                    </div>
                </div>
            </div>

            {
                foodData?.table_number &&
                <div className="foodServiceRoom">
                    <div className="roomLabel">
                        <h5>Table Number</h5>
                    </div>
                    <div className="roomService">
                        <h5>{foodData?.table_number || ""}</h5>
                    </div>
                </div>
            }

   
            
            {foodData.additional_comments && 
                <div className="comments">
                    <div className="comments-label">
                        <h5>Comments</h5>
                    </div>
                    <div className="commentsField">
                        <h5>{foodData.additional_comments}</h5>
                    </div>
                </div>
            }

           
        </div>
        {/* <div className="dining-btn">
            <button onClick={closeRequest}>Cancel Request</button>
        </div> */}
        {renderFoodRequestButtons()}
    </div>
  )
}
